import { RootState } from "redux/rootReducer";

export const selectIsDownloadingMiniStressCSV = (state: RootState) =>
  state.miniStressCsvDownload.loading;
export const miniStressCsvDownloadErrorMessage = (state: RootState) =>
  state.miniStressCsvDownload.error;
export const miniStressCsvDownloadSuccessResponse = (state: RootState) =>
  state.miniStressCsvDownload.miniStressCsvDownloadResponse;
